// StarkFooter — the shared footer for every stark page. Carries the fuller sitemap
// the spare top-nav omits, a one-line positioning blurb, and the console link.
import React from "react";
import { Link } from "react-router-dom";
import { CONSULT_MAILTO } from "../config/site";

const PRODUCT = [
  { to: "/platform", label: "Platform" },
  { to: "/capabilities", label: "Capabilities" },
  { to: "/live", label: "See it live" },
  { to: "/proof", label: "Proof" },
];
const COMPANY = [
  { to: "/how-we-work", label: "How we work" },
  { to: "/feasibility-sprint", label: "Feasibility Sprint" },
  { to: "/built-to-last", label: "Built to last" },
  { to: "/about", label: "About" },
];

export default function StarkFooter() {
  return (
    <>
      <footer className="sk-foot">
        <div className="fcol fbrand">
          <Link to="/" className="sk-brand"><span className="sk-mark">X20</span> CONSULTING</Link>
          <p>AI decisioning you can verify, run in your own cloud, and keep. Every decision is documented, and everything we build is yours.</p>
        </div>
        <div className="fcol">
          <h4>Product</h4>
          {PRODUCT.map((l) => <Link key={l.to} to={l.to}>{l.label}</Link>)}
        </div>
        <div className="fcol">
          <h4>Company</h4>
          {COMPANY.map((l) => <Link key={l.to} to={l.to}>{l.label}</Link>)}
          <a href={CONSULT_MAILTO}>Free consultation</a>
        </div>
      </footer>
      <div className="sk-foot-legal">
        <span>X20 CONSULTING · AI DECISIONING</span>
      </div>
    </>
  );
}
